import x7url from '@/utils/x7url'
type Options = {
  curLanguage: string
}

export const useAccessDocPage = (options: Options) => {
  const { curLanguage } = options
  const route = useRoute()
  // 接入文档页面初始化标志
  const isAccessDocPageInitFlag = ref(false)
  // 显示/隐藏接入文档页面组件
  const isAccessCenterPageShowFlag = ref(false)
  // 接入文档地址
  const accessDocSrc = computed(() => {
    const baseDocURL = `https://${x7url.getDomain('docs')}`
    const doc = route.query.doc
    return window.isInternational
      ? `${baseDocURL}/#/${curLanguage}/`
      : `${baseDocURL}${doc ? '/#/游戏工单对接/接入方法/接口定义' : ''}`
  })

  /**
   * 初始化接入文档页面组件
   */
  const initHandler = () => {
    if (route.name !== 'document' || isAccessDocPageInitFlag.value) return
    isAccessDocPageInitFlag.value = true
  }
  /**
   * 显示接入文档页面组件
   */
  const showHandler = () => {
    isAccessCenterPageShowFlag.value = route.name === 'document'
  }
  /**
   * 处理接入文档页面的显示逻辑
   */
  const accessDocPageHandler = () => {
    initHandler()
    showHandler()
  }

  watch(
    () => route.path,
    () => {
      accessDocPageHandler()
    }
  )

  onMounted(() => {
    accessDocPageHandler()
  })

  return { isAccessDocPageInitFlag, isAccessCenterPageShowFlag, accessDocSrc }
}
